const Main = () => import('@pages/Main')
const Dept = () => import('@pages/contact/dept')
const CbDept = () => import('@pages/contact/cb_dept')
const UserName = () => import('@pages/contact/username')
const CbUserName = () => import('@pages/contact/cb_username')
const Group = () => import('@pages/contact/group')
const CbGroup = () => import('@pages/contact/cb_group')
const Standards = () => import('@pages/contact/standards')
const CommonPhone = () => import('@pages/contact/common_phone')
const CbCommonPhone = () => import('@pages/contact/cb_common_phone')
const Combination = () => import('@pages/contact/combination')

export const main = [
  {
    path: '/',
    component: Main,
    meta: {},
    children: [
      {
        path: '/dept',
        name: 'Dept',
        component: Dept,
        meta: {}
      },
      {
        path: '/cb_dept',
        name: 'CbDept',
        component: CbDept,
        meta: {}
      },
      {
        path: '/username',
        name: 'UserName',
        component: UserName,
        meta: {}
      },
      {
        path: '/cb_username',
        name: 'CbUserName',
        component: CbUserName,
        meta: {}
      },
      {
        path: '/group',
        name: 'Group',
        component: Group,
        meta: {}
      },
      {
        path: '/cb_group',
        name: 'CbGroup',
        component: CbGroup,
        meta: {}
      },
      {
        path: '/standards',
        name: 'Standards',
        component: Standards,
        meta: {}
      },
      {
        path: '/common_phone',
        name: 'CommonPhone',
        component: CommonPhone,
        meta: {}
      },
      {
        path: '/cb_common_phone',
        name: 'CbCommonPhone',
        component: CbCommonPhone,
        meta: {}
      },
      {
        path: '/combination',
        name: 'Combination',
        component: Combination,
        meta: {}
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/main.route.js